import { useNavigate } from 'react-router-dom';
import {
  Box, Button, Card, CardActions, Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import news from '../../assets/icons/fluent_news-16-regular.png';
import notes from '../../assets/icons/gg_notes.png';
import mentor from '../../assets/icons/ph_chalkboard-teacher-light.png';
import button from '../../assets/img/button_news.png';

const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    background: theme.palette.background.card,
    maxWidth: 330,
    minWidth: 330,
    minHeight: 219,
    color: theme.palette.common.white,
    padding: theme.spacing(0, 4),
    borderRadius: '12px',
    [theme.breakpoints.between('lg', 'xl')]: {
      margin: theme.spacing(2, 2, 2, 0),
    },
    [theme.breakpoints.up('xl')]: {
      margin: theme.spacing(6),
    },
  },
  cardNews: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    background: theme.palette.background.card,
    maxWidth: 330,
    minWidth: 330,
    minHeight: 219,
    color: theme.palette.common.white,
    padding: theme.spacing(0, 4),
    borderRadius: '12px',
    [theme.breakpoints.between('lg', 'xl')]: {
      margin: theme.spacing(2, 2, 2, 0),
    },
    [theme.breakpoints.up('xl')]: {
      margin: theme.spacing(6),
    },
  },
  boxCard: {
    padding: theme.spacing(0, 1),
    margin: theme.spacing(0),
    borderRadius: '14px',
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    padding: theme.spacing(1, 5),
    fontFamily: 'Raleway',
    borderRadius: '8px',
  },
  buttonMentor: {
    padding: theme.spacing(1, 10),
    fontFamily: 'Raleway',
    borderRadius: '8px',
  },
  text: {
    fontSize: '24px',
    fontFamily: 'Raleway',
    fontWeight: '600',
  },
  mentor: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.palette.background.card,
    maxWidth: 330,
    minWidth: 330,
    minHeight: 219,
    color: theme.palette.common.white,
    padding: theme.spacing(0, 4),
    margin: theme.spacing(6),
    borderRadius: '12px',
    [theme.breakpoints.between('lg', 'xl')]: {
      margin: theme.spacing(2, 0, 1.7, 3),
    },
    [theme.breakpoints.up('xl')]: {
      margin: theme.spacing(6),
    },
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: theme.spacing(0, 1),
  },
  titleMentor: {
    fontSize: '24px',
    fontFamily: 'Raleway',
    lineHeight: '28px',
    fontWeight: '600',
    maxWidth: 140,
  },
  disableCard: {
    position: 'absolute',
    backdropFilter: 'blur(4px)',
    background: '#0f101150',
    minWidth: 394,
    minHeight: 219,
    padding: theme.spacing(0, 0),
    borderRadius: '14px',
  },
}));

function Tools() {
  const classes = useStyles();
  const navigate = useNavigate();

  const routeToNotesView = () => navigate('/notes');

  const routeToContactMentorView = () => navigate('/mentor');
  return (
    <>
      <Box>
        <Card className={classes.card}>
          <Box className={classes.title}>
            <Typography className={classes.text}>
              Mis notas
            </Typography>
            <CardActions>
              <Button className={classes.button} variant="contained" color="secondary" onClick={routeToNotesView}>Ir</Button>
            </CardActions>
          </Box>
          <img src={notes} alt="notas" />
        </Card>
      </Box>
      <Box>
        <Card className={classes.cardNews}>
          <div className={classes.disableCard} />
          <Box className={classes.title}>
            <Typography className={classes.text}>
              Noticias
            </Typography>
            <CardActions>
              <img src={button} alt="buttonNews" />
            </CardActions>
          </Box>
          <img src={news} alt="noticias" />
        </Card>
      </Box>
      <Box className={classes.boxCard2}>
        <Card className={classes.mentor}>
          <Box className={classes.row}>
            <Box>
              <Typography align="center" className={classes.titleMentor}>
                Contactar con un mentor
              </Typography>
            </Box>
            <img src={mentor} alt="mentor" />
          </Box>
          <CardActions>
            <Button variant="contained" color="secondary" className={classes.buttonMentor} onClick={routeToContactMentorView}>Enviar mensaje</Button>
          </CardActions>
        </Card>
      </Box>
    </>
  );
}

export default Tools;
